module.exports = __webpack_public_path__ + "img/amc.805817a7.png";